import { IconButton } from "@mui/material";
import React, { forwardRef, RefAttributes } from "react";
import SimpleTooltip from "../../../Data/SimpleTooltip";

interface Props {
    onClicked: ((event: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
    icon: React.ElementType;

    title?: string;
    disabled?: boolean;
    testId?: string;

    className?: string;
    size?: "small" | "medium" | "large";
}

const QATableButton: React.FC<Props & RefAttributes<HTMLButtonElement>> = forwardRef((props, ref) => {
    const button = (
        <IconButton
            data-cy={props.testId}
            size={props.size ?? "small"}
            disableRipple
            disableFocusRipple
            disableTouchRipple
            ref={ref}
            className={props.className}
            disabled={props.disabled}
            onClick={props.onClicked}>
            {React.createElement(props.icon, { fontSize: "small" })}
        </IconButton>
    );

    if (props.title) {
        return (
            <SimpleTooltip
                placement="top"
                title={props.title}>
                {button}
            </SimpleTooltip>
        );
    }
    return button;
});

export default QATableButton;
